import { Injectable } from '@angular/core';
import { MyClientsReSingRespondeModel } from '@app/models/myClientsReSingResponse.model';
import { Subject, BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root',
})
export class SubjectService {
  private selectedError = new Subject<any>();
  public eventSelectedError$ = this.selectedError.asObservable();

  private selectedProfileImg = new Subject<string>();
  public eventSelectedProfileImg$ = this.selectedProfileImg.asObservable();

  private stateToggleMenuBS = new BehaviorSubject<boolean>(false);
  public stateMenu$ = this.stateToggleMenuBS.asObservable();

  private stateToggleHeader = new BehaviorSubject<boolean>(false);
  public stateHeader$ = this.stateToggleHeader.asObservable();

  private stateIsMobileBS$ = new BehaviorSubject<boolean>(false);
  public stateIsMobile$ = this.stateIsMobileBS$.asObservable();

  private stateMassiveOperation = new Subject<any>();
  public stateMassiveOperation$ = this.stateMassiveOperation.asObservable();

  private stateFileModal = new Subject<any>();
  public stateFileModal$ = this.stateFileModal.asObservable();

  public showNotificationObs$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public showNotificationObs: Observable<boolean> = this.showNotificationObs$.asObservable();

  private dataClientReSign: BehaviorSubject<MyClientsReSingRespondeModel> =
      new BehaviorSubject<MyClientsReSingRespondeModel>(new MyClientsReSingRespondeModel);
  public dataClientReSign$:Observable<MyClientsReSingRespondeModel> = this.dataClientReSign.asObservable();

  private promissoryNoteToogle: Subject<boolean> = new Subject<boolean>();
  public promissoryNoteToogle$: Observable<boolean> = this.promissoryNoteToogle.asObservable();

  constructor() { }

  sendText(selected: any) {
    this.selectedError.next(selected);
  }

  sendProfileImg(profileImg: any) {
    this.selectedProfileImg.next(profileImg);
  }

  menuCollapse(show: boolean) {
    this.stateToggleMenuBS.next(show);
  }

  headerCollapse(show: boolean) {
    this.stateToggleHeader.next(show);
  }

  isMobile(isMobile: boolean) {
    this.stateIsMobileBS$.next(isMobile);
  }

  returnToPrincipal(state: boolean) {
    this.stateMassiveOperation.next(state);
  }

  removeFiles() {
    this.stateFileModal.next();
  }

  showCustomNotification(show: boolean) {
    this.showNotificationObs$.next(show);
  }

  setClientDataReSign (params: MyClientsReSingRespondeModel) {
    this.dataClientReSign.next(params);
  }

  setPromissoryNoteToogle(newValue: boolean) {
    this.promissoryNoteToogle.next(newValue);
  }
}
